import { findIndex, get, set } from 'lodash'
import { getAllShipment } from 'src/api/shipment'
import { getAllClient } from 'src/api/client'
export default {
  data () {
    return {
      submitting: false,
      localReceipt: {
        id: 0,
        shipments: [],
        total_amount: 0,
        description: '',
        client_id: 0
      },
      suggettionReceiver: {},
      fetchReceiver: false,
      listReceiver: [],
      suggettionShipment: {},
      fetchShipment: false,
      listShipment: [],
      shipmentAdded: [],
      rules: {

      }
    }
  },
  methods: {
    selectReceiver (q) {
      if (q) {
        this.fetchReceiver = true
        getAllClient({limit: 10, q: q}).then(response => {
          if (response.code === 200) {
            this.listReceiver = response.data
            this.fetchReceiver = false
          }
        })
      }
    },
    selectSuggettionReceiver () {
      this.localReceipt.client_id = this.suggettionReceiver.id
      this.listReceiver = []
    },
    selectShipment (q) {
      if (q) {
        this.fetchShipment = true
        getAllShipment({limit: 10, q: q, include: 'receiver,picker'}).then(response => {
          if (response.code === 200) {
            this.listShipment = response.data
            this.fetchShipment = false
          }
        })
      }
    },
    selectSuggettionShipment () {
      if (this.localReceipt.shipments.indexOf(this.suggettionShipment.id) < 0) {
        this.localReceipt.shipments.push(this.suggettionShipment.id)
        this.shipmentAdded.push(this.suggettionShipment)
      }
      this.listShipment = []
    },
    removeShipment (shipment) {
      let index = findIndex(this.shipmentAdded, shipment)
      let sindex = this.localReceipt.shipments.indexOf(shipment.id)
      this.shipmentAdded.splice(index, 1)
      this.localReceipt.shipments.splice(sindex, 1)
    },
    removeZero (key) {
      if (parseInt(get(this.localReceipt, key)) === 0) {
        set(this.localReceipt, key, '')
      }
    },
    addZero (key) {
      if (get(this.localReceipt, key) === '') {
        set(this.localReceipt, key, 0)
      }
    },
    newReceipt () {
      this.localReceipt = {
        id: 0,
        shipments: [],
        total_amount: 0,
        description: '',
        client_id: 0
      }
    }
  },
  mounted () {
    this.newReceipt()
  },
  watch: {
    localReceipt: {
      handler: function (value) {
        if (this.watching) {
          this.changedData = true
        }
      },
      deep: true
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/receipt/mixins/index.js